import { AddEpisodeOfCareModal } from '../../../components/episodes';

interface TrackerAddEpisodeModalProps {
  opened: boolean;
  onClose: () => void;
  onCreated?: () => void;
  fixedPatientId?: string;
}

export function TrackerAddEpisodeModal({
  fixedPatientId,
  ...props
}: TrackerAddEpisodeModalProps): JSX.Element {
  return <AddEpisodeOfCareModal {...props} fixedPatientId={fixedPatientId} />;
}
